export default __webpack_public_path__ + "static/media/Bite Off.2bf66699.png";